import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Reset browser default styles
const style = document.createElement('style');
style.textContent = `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; } body { font-family: Inter, system-ui, -apple-system, sans-serif; -webkit-font-smoothing: antialiased; } input, select, textarea, button { font-family: inherit; }`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
